import { AdjustedLine, ModifierContext } from "../modifier-models";
import { BaseRule } from "../rule-base";

export class Rule0005 extends BaseRule {
    name = '0005 multiple-procedure reduction';
    private factors = [1, 0.75, 0.5, 0.25];

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        // Since we need to know the order and total number of procedures,
        // we'll need to rely on the apply method for this rule
        if (autoApply) {
            line.trace.push('0005: Requires full context for calculation');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0005',
                message: 'Multiple procedure calculation requires full context',
                kind: 'overwrite'
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        const procs = lines.filter(l => !l.isModifier && !l.isConsult && !l.description.includes('0005 not applicable'));
        if (procs.length < 2) return lines;

        procs.sort((a, b) => b.units - a.units);
        procs.forEach((line, idx) => {
            const factor = this.factors[idx] ?? 0.25;
            // Apply modifier to all procedures
            if (!line.modifiers?.includes('0005')) {
                warn.push(`Modifier 0005 missing on procedure ${line.code}.`);
            }
            // First procedure (idx 0) gets factor 1 (100%), others get reduced
            line.adjustedUnits = line.units * factor;
            // Also adjust the price by the same factor
            if (line.adjustedRand) {
                line.adjustedRand = +(line.adjustedRand * factor).toFixed(2);
            }
            line.trace.push(`0005 x${factor}`);
        });
        return lines;
    }
}